module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mask": false,
      "mshow": _vm.show
    }
  }, [_c('div', {
    staticClass: "toast-wrap"
  }, [_c('div', {
    class: _vm.myClass
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('div', {
    class: {
      lighter: _vm.title
    }
  }, [_vm._v("\n            " + _vm._s(_vm.content) + "\n          ")])])]), _vm._v(" "), (_vm.alert) ? _c('div', {
    staticClass: "alert",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.primary) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.confirm) ? _c('div', {
    staticClass: "confirm"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.secondary))]), _vm._v(" "), _c('div', {
    staticClass: "ensure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.primary))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8a0a88"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/toast/index.vue
// module id = 49
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82 83 84 85 86 87 88 89 90 91 92 93 94 95 96 97 98 99 100 101 102 103 104 105 106 107